export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const NODE_ITEMS_START = 'NODE_ITEMS_START';
export const NODE_ITEMS_SUCCESS = 'NODE_ITEMS_SUCCESS';
export const NODE_ITEMS_FAILURE = 'NODE_ITEMS_FAILURE';

export const DOMAIN_ITEMS_START = 'DOMAIN_ITEMS_START';
export const DOMAIN_ITEMS_SUCCESS = 'DOMAIN_ITEMS_SUCCESS';
export const DOMAIN_ITEMS_FAILURE = 'DOMAIN_ITEMS_FAILURE';

export const DIFF_START = 'DIFF_START';
export const DIFF_SUCCESS = 'DIFF_SUCCESS';
export const DIFF_FAILURE = 'DIFF_FAILURE';

export const RETRY_START = 'RETRY_START';
export const RETRY_SUCCESS = 'RETRY_SUCCESS';
export const RETRY_FAILURE = 'RETRY_FAILURE';

export const CSV_OUTPUT_START = 'CSV_OUTPUT_START';
export const CSV_OUTPUT_SUCCESS = 'CSV_OUTPUT_SUCCESS';
export const CSV_OUTPUT_FAILURE = 'CSV_OUTPUT_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
